import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('people', app)
  return store
}
